/** Matches backend SNAKE_CASE_ATTRIBUTE_KEY_RE and Framework Editor key normalizer. */
const SNAKE_CASE_ATTRIBUTE_KEY_RE = /^[a-z0-9]+(_[a-z0-9]+)*$/;

/**
 * Validate a persona schema attribute key (mirrors backend validate_persona_attribute_key).
 * @returns {{ ok: true, key: string } | { ok: false, message: string }}
 */
export function validatePersonaAttributeKey(rawKey) {
  const key = String(rawKey ?? '').trim();
  if (!key) {
    return { ok: false, message: 'Attribute key must not be empty' };
  }
  if (key.includes('.') || key.startsWith('$')) {
    return {
      ok: false,
      message: `Invalid field name '${key}': MongoDB keys must not contain '.' or start with '$'.`,
    };
  }
  if (!SNAKE_CASE_ATTRIBUTE_KEY_RE.test(key)) {
    return {
      ok: false,
      message: `Invalid attribute key '${key}': must be lowercase snake_case (letters and numbers separated by underscores)`,
    };
  }
  return { ok: true, key };
}
